import { Model } from 'backbone';

export const Contact = Model.extend({
  defaults: {
    first_name: '',
    last_name: '',
    school_class: '',
    school_reg: '',
    school_year: ''
  },

  url() {
    return this.get('url');
  },

  isNew() {
    return false;
  }
});



// WEBPACK FOOTER //
// ./epayment/models/contact.js